import { Card, Grid, Paper, Skeleton, useMediaQuery } from "@mui/material";

import usePlatform from "@/hooks/usePlatform";
import useThemeData from "@/hooks/useThemeData";

import { ListViewType } from "../../constants";

export const RoutesItemSkeleton = (props: { usedDetails?: boolean }) => {
  const { isPc, isMobile } = usePlatform();

  const isBreakPoint = useMediaQuery("(min-width:900px)");

  return (
    <Grid
      container
      className={`p-[20px]`}
      sx={{
        ".MuiSkeleton-root": {
          transform: "scale(1)",
        },
      }}
    >
      <Grid item xs={12} md={7}>
        <div className="items-center h-[100%] w-[100%] min-[700px]:flex">
          <Skeleton
            width={isBreakPoint ? 200 : "100%"}
            height={isBreakPoint ? 133 : 200}
            animation="wave"
          />
          <div className="text-center flex-1 space-y-[10px] mt-[10px] min-[700px]:ml-[20px]">
            <Skeleton width={260} height={30} animation="wave" />
            <Skeleton width={260} height={30} animation="wave" />
          </div>
        </div>
      </Grid>

      {isMobile && props.usedDetails ? null : (
        <Grid
          item
          xs={12}
          md={5}
          style={{
            marginTop: isPc ? 0 : "20px",
          }}
        >
          <div className="space-x-[20px] flex items-center justify-between  md:justify-end h-[100%]">
            <Skeleton width={180} height={100} />
            {!props.usedDetails && (
              <div className="flex flex-col">
                <Skeleton width={20} height={20} />
                <Skeleton width={20} height={20} className="!mt-[4px]" />
              </div>
            )}
          </div>
        </Grid>
      )}
    </Grid>
  );
};

const HotelItemSkeleton = (props: { list: any[] }) => {
  const theme = useThemeData();
  return (
    <Grid
      container
      spacing={2}
      className={`pb-[15px]`}
      sx={{
        ".MuiSkeleton-root": {
          transform: "scale(1)",
        },
      }}
    >
      {props.list.map((_, index) => {
        return (
          <Grid item xs={12} sm={6} md={4} lg={3} xl={3} key={index}>
            <Card
              elevation={0}
              style={{
                borderColor: theme.palette.divider,
                borderWidth: 1,
                borderStyle: "solid",
                background: "none",
                borderRadius: "16px",
              }}
              className="rounded-[6px] cursor-pointer"
            >
              <Skeleton height={200} animation="wave" />
              <div className="p-[10px] space-y-[10px]">
                <Skeleton height={20} animation="wave" />
                <Skeleton height={20} width={250} animation="wave" />
                <Skeleton height={20} width={250} animation="wave" />
                <Skeleton height={20} width={150} animation="wave" />
                <div className="flex space-x-[10px]">
                  <Skeleton height={40} width={100} animation="wave" />
                  <Skeleton height={40} width={100} animation="wave" />
                </div>
              </div>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

const RoutesListSkeleton = (props: { count: number; mode: number }) => {
  const list = new Array(Math.max(props.count, 1)).fill("");
  return (
    <div className="mt-[18px]">
      <Paper elevation={0}>
        {list.map((_, index) => {
          return (
            <div key={index}>
              {props.mode === ListViewType.Card ? (
                <HotelItemSkeleton list={list} />
              ) : (
                <RoutesItemSkeleton />
              )}
            </div>
          );
        })}
      </Paper>
    </div>
  );
};

export default RoutesListSkeleton;
